import { useEffect } from 'react';
import { create } from 'zustand';

/**
 * Поиск в шапке оболочки ищет по текущему реестру (README §1 «Поиск справа»).
 * Реестр раздела регистрирует область поиска (название раздела); пока области нет —
 * поле поиска в шапке неактивно, а не «рабочее на вид».
 */
interface SearchScopeState {
  label: string | null;
  setLabel: (label: string | null) => void;
}

export const useSearchScopeStore = create<SearchScopeState>()((set) => ({
  label: null,
  setLabel: (label) => set({ label }),
}));

/** Регистрирует область поиска на время жизни компонента (реестра). */
export function useRegisterSearchScope(label: string | null): void {
  const setLabel = useSearchScopeStore((state) => state.setLabel);
  useEffect(() => {
    setLabel(label);
    return () => setLabel(null);
  }, [label, setLabel]);
}
